import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    contractNumber: "",
    email: "",
    areaCode: "",
    phoneNumber: "",
    repData: {
      id: "",
      zone: "",
      status: "",
      group: "",
      contractNumber: "",
      firstName: "",
      lastName: "",
      email: "",
      areaCode: "",
      phoneNumber: "",
      wasUpdated: "",
      wasUpdatedAt: null
    },
    wasUpdated: false
  },
  getters: {
    CONTRACTNUMBER: state => {
      return state.contractNumber;
    },
    REPDATA: state => {
      return state.repData;
    },
    WASUPDATED: state => {
      return state.wasUpdated;
    }
  },
  mutations: {
    SET_CONTRACTNUMBER: (state, payload) => {
      state.contractNumber = payload;
    },
    SET_REPDATA: (state, payload) => {
      state.repData = payload;
    },
    SET_WASUPDATED: (state, payload) => {
      state.wasUpdated = payload;
    },
    // SET_EMAIL: (state, payload) => {
    //   state.email = payload;
    // },
    // SET_AREACODE: (state, payload) => {
    //   state.repData.areaCode = payload;
    // },
    // SET_PHONENUMBER: (state, payload) => {
    //   state.repData.phoneNumber = payload;
    // },
    updateRep: function(state, { field, value }) {
      Object.assign(state.repData, {
        [field]: value
      });
    }
  },
  actions: {
    SET_CONTRACTNUMBER: (context, payload) => {
      context.commit("SET_CONTRACTNUMBER", payload);
    },
    SET_REPDATA: (context, payload) => {
      context.commit("SET_REPDATA", payload);
    },
    SET_WASUPDATED: (context, payload) => {
      context.commit("SET_WASUPDATED", payload);
    }
    // SET_EMAIL: (context, payload) => {
    //   context.commit("SET_EMAIL", payload);
    // },
    // SET_AREACODE: (context, payload) => {
    //   context.commit("MODALVISIBLE", payload);
    // },
    // SET_PHONENUMBER: (context, payload) => {
    //   context.commit("MODALVISIBLE", payload);
    // }
  }
});
